import { takeLatest } from 'redux-saga/effects';
import { changePassword, CHANGE_PASSWORD, forgottenPassword, FORGOTTEN_PASSWORD, refreshToken, REFRESH_TOKEN } from './actions';

export default [takeLatest(REFRESH_TOKEN, refreshToken), takeLatest(FORGOTTEN_PASSWORD, forgottenPassword), takeLatest(CHANGE_PASSWORD, changePassword)];
